import React, { useEffect, useState } from "react"
import {
  Avatar,
  Box,
  Button,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material"
import { LiaAngleRightSolid } from "react-icons/lia"
import * as Style from "./style"
import moment from "moment"
import { IoCameraOutline } from "react-icons/io5"
import { Link, useNavigate } from "react-router-dom"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import {
  useAccountUpdateMutation,
  useGetProfileQuery,
} from "../../features/Auth/authApi"
import { toast } from "react-toastify"
import dummyImage from "../../images/dummy-icon.png"
import { useGetLanguageQuery } from "../../features/OverViewAuth/overViewApi"
import CenteredSpinner from "../common/CenteredSpinner"
import { languages } from "../Languagejson/language"
import LocationSelector from "../Booking/SearchLocation"
import { setuserProfile } from "../../features/Auth/authSlice"
import { useAppDispatch } from "../../app/hooks"
import CropperModal from "../Modal/CropperModal"
import "./style.css"

interface EditAccountUser {
  // profilePic: string
  name: string
  email: string
  contactNo: string
  // gender: string
  // location: string
  // language: string
  // dob: string
}

interface editprops {
  setEditSave: (value: boolean) => void
  editSave: boolean
  updateLiveProfile: (data: {
    profilePic: string;
    name: string
    email: string
    contactNo: string
  }) => void;
  currentProfile: {
    profilePic: string;
    name: string
    email: string
    contactNo: string
  }
}

const EditAccount = ({ setEditSave, editSave, updateLiveProfile, currentProfile }: editprops) => {
  const [
    accountUpdate,
    { data: updateData, error, isLoading: updateIsloading },
  ] = useAccountUpdateMutation()
  const [previewImage, setPreviewImage] = useState<string | null>(null)
  const [fileUpload, setFileUpload] = useState<File | null>(null)
  const [isInputFocused, setIsInputFocused] = useState(false)
  const [loactionSearchData, setLocationSearchData] = useState<string>("")
  const [errorMsg, setErrorMsg] = useState<string>("")
  const [genderOption, setGenderOption] = useState("")
  const [cropperOpen, setCropperOpen] = useState(false)
  const [imageSrc, setImageSrc] = useState("")
  const [fileExtension, setFileExtension] = useState("png")
  const dispatch = useAppDispatch()
  const { data: getProfile, isFetching, isLoading } = useGetProfileQuery({})

  useEffect(() => {
    if (getProfile) {
      dispatch(setuserProfile(getProfile))
    }
  }, [getProfile])

  const naviage = useNavigate()

  const handleGender = (e: any) => {
    setGenderOption(e.target.value)
  }

  const [selectedLanguages, setSelectedLanguages] = useState<string[]>([])
  const [open, setOpen] = useState(false)
  const handleLanguageChange = (event: SelectChangeEvent<string[]>,) => {
    const selected = event.target.value as string[]
    if (selected.length > 2) {
      toast.warning("You Can Select Up To 2 Languages Only");
      return;
    }
    setOpen(false)
    setSelectedLanguages(selected)
  }

  // const handleLanguageChange = (
  //   event: React.ChangeEvent<{ value: unknown }>,
  // ) => {
  //   const selected = event.target.value as string[]
  //   if (selected.length > 2) {
  //     selected.splice(0, selected.length - 2)
  //   }

  //   setSelectedLanguages(selected)
  // }

  const handleFieldChange = (field: string, value: string) => {
    updateLiveProfile({
      ...currentProfile,
      [field]: value
    })
  }
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return;

    if (!file.type.match('image.*')) {
      toast.error('Please Select An Image File')
      return
    }

    if (file.size > 5 * 1024 * 1024) {
      toast.error('Image Size Should Be Less Than 5MB')
      return
    }

    const extension = file.name.split('.').pop()?.toLowerCase() || 'png'
    setFileExtension(extension)

    const reader = new FileReader()
    reader.onload = () => {
      const result = reader.result as string;
      setImageSrc(result);
      setCropperOpen(true);
    }
    reader.readAsDataURL(file)
  }

  const handleCroppedImage = async (file: File) => {
    setFileUpload(file)
    const reader = new FileReader()
    reader.onloadend = () => {
      const result = reader.result as string
      setPreviewImage(result)
      updateLiveProfile({
        ...currentProfile,
        profilePic: result
      })
    }
    reader.readAsDataURL(file)
    setCropperOpen(false)
  }

  const dobSchema = yup
    .string()
    .nullable()
    // Test for valid date format and reasonable year
    .test(
      "valid-date",
      "Please enter a valid date of birth",
      function (value) {
        if (!value) return true; // allow empty
        const selectedDate = new Date(value);
        const year = selectedDate.getFullYear();
        // Check if the date is invalid or the year is too old
        return !isNaN(selectedDate.getTime()) && year > 1900;
      }
    )
    .test(
      "same-date",
      "The date of birth cannot be today",
      function (value) {
        if (!value) return true; // Allow empty value
        const selectedDate = new Date(value);
        const currentDate = new Date();
        return selectedDate.toDateString() !== currentDate.toDateString();
      }
    )
    .test(
      "age",
      "The Age Of Customer Should Be 18 Years Or Above",
      function (value) {
        if (!value) return true; // Allow empty value
        const selectedDate = new Date(value);
        const currentDate = new Date();
        const age = currentDate.getFullYear() - selectedDate.getFullYear();
        const monthDiff = currentDate.getMonth() - selectedDate.getMonth();
        return (
          age >= 18 &&
          (age > 18 ||
            (age === 18 &&
              (monthDiff > 0 ||
                (monthDiff === 0 &&
                  currentDate.getDate() >= selectedDate.getDate()))))
        );
      }
    );


  const schemaResolver = yup.object().shape({
    name: yup
      .string()
      .required("Please Enter Name")
      .transform((value) => value.trim())
      .matches(/^[a-zA-Z]+(?: [a-zA-Z]+)*$/, {
        message:
          "Name Should Only Contain Letters And A Single Space Between Words",
        excludeEmptyString: true,
      })
      .min(3, "Name Should Be Of 3-25 Characters Only")
      .max(25, "Name Should Be Of 3-25 Characters Only"),
    email: yup.string().email().required("Please Enter An Email"),
    contactNo: yup
      .string()
      .required("Please Enter Phone Number")
      .matches(/^(1\s?)?[2-9]\d{2}[2-9]\d{6}$/, "Please Enter A Valid Canadian Phone Number (e.g. 604XXXXXXX)")
      .test(
        "Not-All-Zeros",
        "Please Enter A Valid Phone Number.",
        (value) => value !== undefined && !/^0+$/.test(value),
      ),
    // gender: yup.string().required("Please enter gender"),
    // language: yup.string().required("Please enter language"),
    // location: yup.string().required("Please enter address"),
    // dob: yup.string().required("Please enter age"),

    dob: dobSchema,
  })

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm<EditAccountUser, any>({
    resolver: yupResolver(schemaResolver),
  })

  const onSubmit = (data: any) => {
    const formData = new FormData()
    formData.append("name", data?.name)
    formData.append("email", data?.email)
    formData.append("contactNo", data?.contactNo)
    formData.append("gender", genderOption)
    formData.append("address.location", loactionSearchData || "")
    formData.append("language", selectedLanguages as any)
    formData.append("dob", data?.dob)
    // Append the file to FormData
    if (fileUpload) {
      formData.append("profilePic", fileUpload)
    }

    if (loactionSearchData !== "") {
      accountUpdate(formData)
    } else {
      setErrorMsg("Please Enter Your Location")
    }
  }

  useEffect(() => {
    if (getProfile && getProfile?.data) {
      setValue("name", getProfile?.data.name)
      setValue("email", getProfile?.data.email)
      setValue("contactNo", getProfile?.data.contactNo)
      // setValue("location" as any, getProfile?.data?.address?.location as any)
      setLocationSearchData(getProfile?.data?.address?.location)
      setGenderOption(getProfile?.data?.gender || "")

      setSelectedLanguages(getProfile?.data.language || [])

      const dateFormat = moment(getProfile?.data?.dob).format("YYYY-MM-DD")
      let formattedDate

      if (getProfile?.data?.dob) {
        // If the date from the backend is defined, format it
        formattedDate = moment(getProfile?.data?.dob).format("YYYY-MM-DD")
      } else {
        // If the date from the backend is undefined, set formattedDate to null or any default value you prefer
        formattedDate = null // You can set it to null or any other default value
      }

      // setValue("gender", getProfile.data.gender || " ")
      // const inputDate = new Date(getProfile.data.dob)
      // const formattedDate = inputDate.toISOString().split("T")[0]
      setValue("dob" as any, formattedDate || "")
    }
  }, [getProfile, isInputFocused])

  // for modal changepasswords
  const tagStyle = {
    border: "1px solid #F475A4",
    padding: "4px 8px",
    borderRadius: "8px",
    marginRight: "8px", // Add space between tags
    marginBottom: "8px", // Add space below each row of tags
    display: "inline-block",
    backgroundColor: "#F475A4", // Light background color
    color: " #fff",
  }

  useEffect(() => {
    if (updateData?.message) {
      toast.success(updateData?.message)
      setEditSave(!editSave)
    } else {
      toast.error((error as any)?.data?.message)
    }
  }, [updateData, error])

  return (
    <>
      {" "}
      {isLoading ? (
        <>
          <CenteredSpinner />
        </>
      ) : (
        <Style.Overview>
          <Grid container>
            <Grid xs={12} className="ps-2 ps-xl-0">
              <Box className="review-card p-4">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Grid container className="mb-4">
                    <Grid xs={12} sm={4} lg={4}>
                      <Typography variant="body1">Profile Photo</Typography>
                    </Grid>
                    <Grid xs={12} sm={8} lg={8}>
                      <Box className="d-inline-block position-relative ">
                        <img
                          src={
                            previewImage || getProfile?.data?.profilePic
                              ? previewImage || getProfile?.data?.profilePic
                              : dummyImage
                          }
                          className="edit-profile "
                        />

                        <input
                          type="file"
                          id="upload-profile-pic"
                          className="d-none"
                          onChange={onChange}
                          accept="image/*"
                        />
                        <label
                          htmlFor="upload-profile-pic"
                          className="upload-label"
                        >
                          <IoCameraOutline />
                        </label>
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-1">
                    <Grid xs={12} sm={4} lg={4}>
                      <Typography variant="body1">
                        Name <span className="text-danger">*</span>
                      </Typography>
                    </Grid>
                    <Grid xs={12} sm={8} lg={8}>
                      <Input
                        placeholder="Name"
                        className="feature-field font-16 input-border"
                        fullWidth
                        {...register("name")}
                        onChange={(e) => handleFieldChange('name', e.target.value)}
                      />
                      <p className="text-danger">{errors?.name?.message}</p>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-1">
                    <Grid xs={12} sm={4} lg={4}>
                      <Typography variant="body1">
                        E-Mail<span className="text-danger">*</span>
                      </Typography>
                    </Grid>
                    <Grid xs={12} sm={8} lg={8}>
                      <Input
                        placeholder="Email"
                        className="feature-field icon-field font-16 "
                        fullWidth
                        {...register("email")}
                        onChange={(e) => handleFieldChange('email', e.target.value)}
                        startAdornment={
                          <InputAdornment position="start">
                            {/* <MdOutlineMail /> */}
                          </InputAdornment>
                        }
                        disabled
                      />
                      <p className="text-danger">{errors.email?.message}</p>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-1">
                    <Grid xs={12} sm={4} lg={4}>
                      <Typography variant="body1">
                        Phone Number<span className="text-danger">*</span>
                      </Typography>
                    </Grid>
                    <Grid xs={12} sm={8} lg={8}>
                      <Input
                        type="text"
                        inputMode="numeric"
                        placeholder="Phone Number"
                        className="feature-field font-16 icon-field"
                        fullWidth
                        {...register("contactNo")}
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                            "Delete",
                            "Home",
                            "End",
                          ]
                          if (
                            event.ctrlKey ||
                            event.metaKey ||
                            allowedKeys.includes(event.key)
                          ) {
                            return
                          }
                          const numericRegex = /^[0-9]$/
                          if (!numericRegex.test(event.key)) {
                            event.preventDefault()
                          }
                        }}
                        onChange={(e) => handleFieldChange('contactNo', e.target.value)}
                        startAdornment={
                          <InputAdornment position="start">
                            {/* <BsTelephone /> */}
                          </InputAdornment>
                        }
                      />
                      <p className="text-danger">{errors.contactNo?.message}</p>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-1">
                    <Grid xs={12} sm={4} lg={4}>
                      <Typography variant="body1" className="mb-2 mb-md-0">Gender</Typography>
                    </Grid>
                    <Grid xs={12} sm={8} lg={8}>
                      <FormControl fullWidth sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "#C1C1C1" },
                          "&:hover fieldset": { borderColor: "#F475A4" },
                          "&.Mui-focused fieldset": { borderColor: "#F475A4" },
                        },
                        "& .MuiInputLabel-root": {
                          color: "#000", // default label color
                          "&.Mui-focused": { color: "#F475A4" }, // pink on focus
                        }
                      }}
                      >
                        <InputLabel id="select-lan" className="bg-white">
                          Select Your Gender
                        </InputLabel>
                        <Select
                          className="feature-field font-16"
                          {...register("gender" as any)}
                          value={genderOption}
                          onChange={handleGender}
                          fullWidth
                        >
                          <MenuItem value="Male">Male</MenuItem>
                          <MenuItem value="Female">Female</MenuItem>
                          <MenuItem value="Others">Others</MenuItem>
                        </Select>
                      </FormControl>
                      <p className="text-danger">
                        {(errors as any).gender?.message}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-3">
                    <Grid xs={12} sm={4} lg={4}>
                      <Typography variant="body1" className="mb-2 mb-md-0">Language</Typography>
                    </Grid>

                    <Grid xs={12} sm={8} lg={8}>
                      <FormControl fullWidth sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "#C1C1C1" },
                          "&:hover fieldset": { borderColor: "#F475A4" },
                          "&.Mui-focused fieldset": { borderColor: "#F475A4" },
                        },
                        "& .MuiInputLabel-root": {
                          color: "#000",
                          "&.Mui-focused": { color: "#F475A4" },
                        }
                      }}
                      >
                        <InputLabel id="select-lan" className="bg-white">
                          Select Language
                        </InputLabel>
                        <Select
                          labelId="select-language-label"
                          label="Select Language"
                          className="feature-field font-16"
                          open={open}
                          onOpen={() => setOpen(true)}
                          onClose={() => setOpen(false)}
                          value={selectedLanguages}
                          multiple
                          onChange={handleLanguageChange}
                          fullWidth
                          renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                              {selected.map((value) => (
                                <Chip
                                  key={value}
                                  label={value}
                                  onDelete={() => {
                                    setSelectedLanguages(selectedLanguages.filter(lang => lang !== value));
                                  }}
                                  onMouseDown={(event) => {
                                    event.stopPropagation();
                                  }}
                                />
                              ))}
                            </Box>
                          )}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 250,
                                width: 250,
                              },
                            },
                          }}
                        >
                          {languages?.map((item) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {/* <p className="text-danger">
                          {(errors as any).language?.message}
                        </p> */}
                    </Grid>
                  </Grid>
                  <Grid container className="mb-1">
                    <Grid xs={12} sm={4} lg={4}>
                      <Typography variant="body1">Date Of Birth</Typography>
                    </Grid>
                    <Grid xs={12} sm={8} lg={8}>
                      <Input
                        type={"date"}
                        placeholder="DOB"
                        className="feature-field font-16"
                        fullWidth
                        {...register("dob" as any)}
                      />
                      <p className="text-danger">
                        {(errors as any).dob?.message}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-1">
                    <Grid xs={12} sm={4} lg={4} >
                      <Typography variant="body1" className="mb-2 mb-md-0">
                        Location<span className="text-danger">*</span>
                      </Typography>
                    </Grid>
                    <Grid xs={12} sm={8} lg={8}>
                      {/* <Input
                          placeholder="Location"
                          className="feature-field font-16"
                          fullWidth
                          multiline
                          rows={3}
                          {...register("location" as any)}
                        /> */}

                      <LocationSelector
                        setLocationSearchData={setLocationSearchData}
                        placeholder="Enter location"
                        setErrorMsg={setErrorMsg as any}
                        loactionSearchData={loactionSearchData}
                        bookingDetailsShow={false}
                        disabled={false}
                      />
                      <p className="text-danger pt-2">
                        {errorMsg}
                        {/* {(errors as any).location?.message} */}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-1">
                    <Grid xs={12}>
                      <Box className="text-end">
                        <Button
                          className="view-profile active text-capitalize"
                          type="submit"
                        >
                          {updateIsloading ? (
                            <Typography fontSize={1}>
                              <CircularProgress
                                style={{ color: "pink", fontSize: 24 }}
                                size={24}
                              />
                            </Typography>
                          ) : (
                            "Save Changes"
                          )}
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
            {/* )} */}
          </Grid>

          <CropperModal
            open={cropperOpen}
            onClose={() => setCropperOpen(false)}
            level={1}
            data={{ imageSrc, extension: fileExtension }}
            setResults={handleCroppedImage}
          />

        </Style.Overview>
      )}
      {/* <ChangePasswordModal opens={open} handleClose={handleClose} /> */}
    </>
  )
}
export default EditAccount
